/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';

export const Container = (props) => (
  <div
    sx={{
      fontSize: '1.8rem',
      lineHeight: 1.44,
      px: ['1.5rem', '2.8rem', '6.4rem'],
      pt: ['6rem', '6rem', '5rem'],
      pb: ['0rem', '6rem', '8rem'],
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      flexWrap: 'wrap',
    }}
    {...props}
  />
);

export const Title = (props) => (
  <div
    sx={{
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      fontWeight: 'bold',
      mb: '2.6rem',
    }}
    {...props}
  />
);

export const HeaderContentContainer = (props) => {
  const { columns } = props;

  return (
    <div
      sx={{
        width: ['50%', `${100 / columns}%`],
        maxWidth: ['calc(50% - 1rem)', `calc(${100 / columns}% - 1.4rem)`, `calc(${100 / columns}% - 3.2rem)`],
        marginBottom: ['2.4rem', '4.7rem'],
      }}
      {...props}
    />
  );
};

HeaderContentContainer.propTypes = {
  columns: PropTypes.number.isRequired,
};
